/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedBrandRequest
 */
export interface APIPatchedBrandRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPatchedBrandRequest
     */
    name?: string;
}

/**
 * Check if a given object implements the APIPatchedBrandRequest interface.
 */
export function instanceOfAPIPatchedBrandRequest(value: object): value is APIPatchedBrandRequest {
    return true;
}

export function APIPatchedBrandRequestFromJSON(json: any): APIPatchedBrandRequest {
    return APIPatchedBrandRequestFromJSONTyped(json, false);
}

export function APIPatchedBrandRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedBrandRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function APIPatchedBrandRequestToJSON(value?: APIPatchedBrandRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

